import React from 'react';
import TournamentInfo from "../../components/TournamentInfo/TournamentInfo.jsx";
import {useSelector} from "react-redux";
import TournamentTopPlayers from "../../components/TournamentTopPlayers/TournamentTopPlayers.jsx";
import TournamentList from "../../components/Tables/TournamentList.jsx";

const Tournament = React.memo(function () {
    const isMobile = useSelector(state => state.user.isMobile);

    return <div className="tournament-lobby">
        {
            isMobile && <TournamentList/>
        }
        {
            !isMobile && <>
                <div className='tournament-top-players'>
                    <TournamentTopPlayers />
                </div>
                <div className="tournament-wrapper">
                    <TournamentList/>
                    <TournamentInfo />
                </div>
            </>
        }
    </div>
})

export default Tournament